import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox, faBoxArchive } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './InboxStatusTabs.css';

export type InboxTab = 'inbox' | 'archived';

interface Props {
  activeTab: InboxTab;
  onTabChange: (tab: InboxTab) => void;
  unreadCount?: number;
  archivedCount?: number;
}

export default function InboxStatusTabs({
  activeTab,
  onTabChange,
  unreadCount = 0,
  archivedCount = 0,
}: Props) {
  // Inbox carries the unread badge; Archived shows its total as plain grey
  // text, not a badge (Asana 1219952262403623, Decision 6).
  const tabs: { key: InboxTab; label: string; icon: IconDefinition; badgeCount: number; plainCount?: number }[] = [
    { key: 'inbox', label: 'Inbox', icon: faInbox, badgeCount: unreadCount },
    { key: 'archived', label: 'Archived', icon: faBoxArchive, badgeCount: 0, plainCount: archivedCount },
  ];

  return (
    <div className="inbox-status-tabs">
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`inbox-status-tab ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => onTabChange(tab.key)}
          type="button"
        >
          <FontAwesomeIcon icon={tab.icon} className="inbox-tab-icon" />
          <span className="inbox-tab-label">{tab.label}</span>
          {tab.badgeCount > 0 && (
            <span className="inbox-tab-badge">{tab.badgeCount}</span>
          )}
          {tab.plainCount !== undefined && tab.plainCount > 0 && (
            <span className="inbox-tab-count">{tab.plainCount}</span>
          )}
        </button>
      ))}
    </div>
  );
}
